var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFilterSliders = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.31799 4.30402V4.86402H2.73599C2.58201 4.86402 2.45599 4.738 2.45599 4.58402C2.45599 4.43003 2.58201 4.30402 2.73599 4.30402H4.31799Z",
    fill: "#ABACAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.544 4.58402C13.544 4.738 13.418 4.86402 13.264 4.86402H5.914V4.30402H13.264C13.418 4.30402 13.544 4.43003 13.544 4.58402Z",
    fill: "#ABACAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79999 3.26801V5.88601H6.41799V3.26801H3.79999ZM5.91399 5.38201H4.31799V3.77201H5.92799V5.38201H5.91399Z",
    fill: "#ABACAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39999 7.72V8.28H2.73599C2.58201 8.28 2.45599 8.15399 2.45599 8C2.45599 7.84601 2.58201 7.72 2.73599 7.72H9.39999Z",
    fill: "#ABACAD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.544 8C13.544 8.15399 13.418 8.28 13.264 8.28H11.01V7.72H13.264C13.418 7.72 13.544 7.84601 13.544 8Z",
    fill: "#ABACAD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88202 6.68399V9.30199H11.5V6.68399H8.88202ZM11.01 8.79799H9.40002V7.18799H11.01V8.79799Z",
    fill: "#ABACAD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.31799 11.136V11.696H2.73599C2.58201 11.696 2.45599 11.57 2.45599 11.416C2.45599 11.262 2.58201 11.136 2.73599 11.136H4.31799Z",
    fill: "#ABACAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.544 11.416C13.544 11.57 13.418 11.696 13.264 11.696H5.914V11.136H13.264C13.418 11.136 13.544 11.262 13.544 11.416Z",
    fill: "#ABACAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79999 10.114V12.732H6.41799V10.114H3.79999ZM5.91399 12.228H4.31799V10.618H5.92799V12.228H5.91399Z",
    fill: "#ABACAD"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFilterSliders);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/filter-sliders.4787461a05c2ce2d29127e49b615fc64.svg";